import React from 'react';

export interface AdvancedVariableMapping {
  variableName: string;
  filterField?: string;
  operator?: string;
}

/**
 * Provides the list of enabled board variables available for use as {{variableName}} references in filter values.
 * Consumed by FilterValueInput to allow selecting a variable as a filter value.
 */
const BoardVariablesContext = React.createContext<AdvancedVariableMapping[]>([]);

export default BoardVariablesContext;
